export default class ToolLine {
	constructor(config) {
		this.el = config.el || document.querySelector(".js-toolline");
		this.init();
	}
	init() {
		if (this.el) {
			this.attachEvents();
		}
	}
	attachEvents() {
		let trigger = this.el.querySelector(".js-toolline-print");
		if (trigger) {
			trigger.addEventListener("click", event => {
				event.preventDefault();
				window.print();
			});
		}
	}
}
